module.exports = __webpack_public_path__ + "img/swh.beee037e.svg";